import { IAddressSchema } from '../../indigofair/data/IAddressSchema';
import { SettingConst } from '../../types';

/**
 * The frontend will merge this value with DEFAULT_ADDRESS_SCHEMA in addressSchema.ts in web-ui to calculate the actualdefault address schema. We'll use the merged address schema to format addresses and address input forms for countries that don't have an explicit address schema in AddressValidationSchemaCatalog.
 */
export const DEFAULT_ADDRESS_SCHEMA_OVERRIDE =
  'DEFAULT_ADDRESS_SCHEMA_OVERRIDE' as SettingConst<
    'DEFAULT_ADDRESS_SCHEMA_OVERRIDE',
    IAddressSchema,
    'RETAILER' | 'MAKER' | 'ADMIN'
  >;
